import { BackendModel, BackendService } from "../../core/backend.service";

export class ActualizacionPrecio extends BackendModel {

  static path = '/modificaciones-precio/';

  id: number;
  porPorcentaje: boolean;
  aumentoPrecio: number; 
  categoriaId: number;
  productoId: number;
  etiqueta:string;
  fechaDesde: Date | 'dd/MM/yyyy';
  fechaHasta: Date | 'dd/MM/yyyy';
  nombreObjeto:String;

  constructor(protected backendService: BackendService, model?: ActualizacionPrecio) {
    super(backendService, model);
  }

}



// WEBPACK FOOTER //
// ./src/app/productos/modificacion-precio/actualizacion-precio.model.ts